import { catalogDa } from "./catalog-da";
import { catalogDe } from "./catalog-de";
import { catalogEn } from "./catalog-en";
import { catalogFr } from "./catalog-fr";
import { catalogUk } from "./catalog-uk";

/**
 * Optional environment variable QUIZ_UI_LOCALES (comma-separated BCP 47 primary tags): permitted only in unit tests—narrow configured supported tags when exercising validation or UI gates keyed off that list; choosing one active locale alone does not restrict the advertised set. MUST NOT be set in deployed or shared environments. Traceability: specification repository features/training-material-quiz/design.md (Supported UI locales).
 */

/** Supported UI locales (BCP 47 primary tags). */
export type SupportedLocale = "en" | "de" | "fr" | "da" | "uk";

/** Message bundles keyed by locale. */
export const catalogs: Record<SupportedLocale, Record<string, string>> = {
  en: catalogEn,
  de: catalogDe,
  fr: catalogFr,
  da: catalogDa,
  uk: catalogUk,
};
